import axios from "axios";
import React, { useState, useEffect } from "react";
import moment from "moment";
import jwt_decode from "jwt-decode";
import { Link, useHistory, useParams, useLocation } from "react-router-dom";
import { injectIntl, useIntl, FormattedMessage } from "react-intl";
import { useForm, RegisterOptions } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const schema = yup.object().shape({
  gameplay: yup.string().required(),
  gameplayShare: yup.boolean().required(),
  gameplayComment: yup.string().required(),
  narrativa: yup.string().required(),
  narrativaShare: yup.boolean().required(),
  narrativaComment: yup.string().required(),
  arte: yup.string().required(),
  arteShare: yup.boolean().required(),
  arteComment: yup.string().required(),
  som: yup.string().required(),
  somShare: yup.boolean().required(),
  somComment: yup.string().required(),
  inovacao: yup.string().required(),
  inovacaoShare: yup.boolean().required(),
  inovacaoComment: yup.string().required(),
});

function RatingGameSelecionadorGame({ game }) {
  const intl = useIntl();
  const [isShow, setIsShow] = useState(true);
  const history = useHistory();
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });
  const user = jwt_decode(localStorage.getItem("token"));

  const onSubmit = (data) => {
    const dados = new FormData();

    dados.append("gameplay", data.gameplay);
    dados.append("gameplayShare", data.gameplayShare);
    dados.append("gameplayComment", data.gameplayComment);
    dados.append("narrativa", data.narrativa);
    dados.append("narrativaShare", data.narrativaShare);
    dados.append("narrativaComment", data.narrativaComment);
    dados.append("arte", data.arte);
    dados.append("arteShare", data.arteShare);
    dados.append("arteComment", data.arteComment);
    dados.append("som", data.som);
    dados.append("somShare", data.somShare);
    dados.append("somComment", data.somComment);
    dados.append("inovacao", data.inovacao);
    dados.append("inovacaoShare", data.inovacaoShare);
    dados.append("inovacaoComment", data.inovacaoComment);
    // dados.append("categoriaExtra", data.categoriaExtra);
    // dados.append("categoriaExtraShare", data.categoriaExtraShare);
    // dados.append("categoriaExtraComment", data.categoriaExtraComment);
    dados.append("event_id", game.event_id);
    dados.append("game_id", game.id);
    dados.append("team_id", game.team.id);
    dados.append("type_user", user.type);

    let url = `/api/v1/rating/game/${game.id}`;

    axios
      .post(url, dados, {
        headers: {
          "x-access-token": localStorage.getItem("token"),
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          setIsShow(false);
          alert(intl.formatMessage({ id: "rating.save" }));
        } else {
          alert(intl.formatMessage({ id: "rating.save.fail" }));
          console.log("Não salvou", res);
        }
      })
      .catch((e) => {
        if (e.response.status == 411) {
          alert(intl.formatMessage({ id: "inscriptions.edit.validate.date" }));
        } else {
          alert(intl.formatMessage({ id: "inscriptions.edit.response.fail" }));
        }
        console.log("e", e.response);
      });
  };

  return (
    isShow && (
      <div className={`row`}>
        <div className="col-12">
          <div className="row">
            <div className="col-xx-1 col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12">
              <Link
                to={{
                  pathname: `/games/detail/${game.id}`,
                  state: {
                    game,
                  },
                }}
                title="Detalhe Jogo"
              >
                <div className="image-event">
                  <img src={game.image} alt={game.name} />
                </div>
              </Link>
            </div>
            <div className="col-xx-11 col-xl-11 col-lg-10 col-md-10 col-sm-9 col-12">
              <div className="info">
                <div className="row w-100">
                  <Link
                    to={{
                      pathname: `/games/detail/${game.id}`,
                      state: {
                        game,
                      },
                    }}
                    title="Detalhe Jogo"
                  >
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                      <h3>{game.name}</h3>
                      <p>{game.description}</p>
                    </div>
                  </Link>
                  <div className="col-12">
                    <form
                      className="form-custom"
                      onSubmit={handleSubmit(onSubmit)}
                    >
                      <div className="form-row">
                        <div className={`form-group col-md-12 mb-4`}>
                          <div
                            className={`${
                              errors?.gameplay ? "input-error" : ""
                            }`}
                          >
                            <h3>
                              <FormattedMessage id="games.detail.curators-evaluation.gameplay" />
                            </h3>
                            <div className="content-radio">
                              <div className="radio">
                                <input
                                  type="radio"
                                  className="form-control form-control-sm"
                                  value={"Sim"}
                                  {...register("gameplay")}
                                />
                                <FormattedMessage id="sim" />
                              </div>
                              <div className="radio">
                                <input
                                  type="radio"
                                  className="form-control form-control-sm"
                                  value={"Não"}
                                  {...register("gameplay")}
                                />
                                <FormattedMessage id="nao" />
                              </div>
                              <div className="radio">
                                <input
                                  type="radio"
                                  className="form-control form-control-sm"
                                  value={"Talvez"}
                                  {...register("gameplay")}
                                />
                                <FormattedMessage id="talvez" />
                              </div>
                            </div>
                          </div>
                          <div
                            className={`${
                              errors?.gameplayShare ? "input-error" : ""
                            }`}
                          >
                            <h3>
                              <FormattedMessage id="deseja-compartilhar-esse-comentario-com-o-desenvolvedor?" />
                            </h3>
                            <div className="content-radio">
                              <div className="radio">
                                <input
                                  type="radio"
                                  className="form-control form-control-sm"
                                  value={true}
                                  {...register("gameplayShare", {
                                    value: "false",
                                  })}
                                />
                                <FormattedMessage id="sim" />
                              </div>
                              <div className="radio">
                                <input
                                  type="radio"
                                  className="form-control form-control-sm"
                                  value={false}
                                  {...register("gameplayShare")}
                                />
                                <FormattedMessage id="nao" />
                              </div>
                            </div>
                          </div>
                          <div
                            className={`${
                              errors?.gameplayComment ? "input-error" : ""
                            }`}
                          >
                            <textarea
                              placeholder="Comentário"
                              className="form-control form-control-sm feedback-categoria"
                              {...register("gameplayComment")}
                            />
                          </div>
                        </div>
                        <div className={`form-group col-md-12 mb-4`}>
                          <div
                            className={`${
                              errors?.narrativa ? "input-error" : ""
                            }`}
                          >
                            <h3>
                              <FormattedMessage id="games.detail.curators-evaluation.narrative" />
                            </h3>
                            <div className="content-radio">
                              <div className="radio">
                                <input
                                  type="radio"
                                  className="form-control form-control-sm"
                                  value={"Sim"}
                                  {...register("narrativa")}
                                />
                                <FormattedMessage id="sim" />
                              </div>
                              <div className="radio">
                                <input
                                  type="radio"
                                  className="form-control form-control-sm"
                                  value={"Não"}
                                  {...register("narrativa")}
                                />
                                <FormattedMessage id="nao" />
                              </div>
                              <div className="radio">
                                <input
                                  type="radio"
                                  className="form-control form-control-sm"
                                  value={"Talvez"}
                                  {...register("narrativa")}
                                />
                                <FormattedMessage id="talvez" />
                              </div>
                            </div>
                          </div>
                          <div
                            className={`${
                              errors?.narrativaShare ? "input-error" : ""
                            }`}
                          >
                            <h3>
                              <FormattedMessage id="deseja-compartilhar-esse-comentario-com-o-desenvolvedor?" />
                            </h3>
                            <div className="content-radio">
                              <div className="radio">
                                <input
                                  type="radio"
                                  className="form-control form-control-sm"
                                  value={true}
                                  {...register("narrativaShare", {
                                    value: "false",
                                  })}
                                />
                                <FormattedMessage id="sim" />
                              </div>
                              <div className="radio">
                                <input
                                  type="radio"
                                  className="form-control form-control-sm"
                                  value={false}
                                  {...register("narrativaShare")}
                                />
                                <FormattedMessage id="nao" />
                              </div>
                            </div>
                          </div>
                          <div
                            className={`${
                              errors?.narrativaComment ? "input-error" : ""
                            }`}
                          >
                            <textarea
                              placeholder="Comente"
                              className="form-control form-control-sm feedback-categoria"
                              {...register("narrativaComment")}
                            />
                          </div>
                        </div>
                        <div className="form-group col-md-12 mb-4">
                          <div
                            className={`${errors?.arte ? "input-error" : ""}`}
                          >
                            <h3>
                              <FormattedMessage id="games.detail.curators-evaluation.art" />
                            </h3>
                            <div className="content-radio">
                              <div className="radio">
                                <input
                                  type="radio"
                                  className="form-control form-control-sm"
                                  value={"Sim"}
                                  {...register("arte")}
                                />
                                <FormattedMessage id="sim" />
                              </div>
                              <div className="radio">
                                <input
                                  type="radio"
                                  className="form-control form-control-sm"
                                  value={"Não"}
                                  {...register("arte")}
                                />
                                <FormattedMessage id="nao" />
                              </div>
                              <div className="radio">
                                <input
                                  type="radio"
                                  className="form-control form-control-sm"
                                  value={"Talvez"}
                                  {...register("arte")}
                                />
                                <FormattedMessage id="talvez" />
                              </div>
                            </div>
                          </div>
                          <div
                            className={`${
                              errors?.arteShare ? "input-error" : ""
                            }`}
                          >
                            <h3>
                              <FormattedMessage id="deseja-compartilhar-esse-comentario-com-o-desenvolvedor?" />
                            </h3>
                            <div className="content-radio">
                              <div className="radio">
                                <input
                                  type="radio"
                                  className="form-control form-control-sm"
                                  value={true}
                                  {...register("arteShare", {
                                    value: "false",
                                  })}
                                />
                                <FormattedMessage id="sim" />
                              </div>
                              <div className="radio">
                                <input
                                  type="radio"
                                  className="form-control form-control-sm"
                                  value={false}
                                  {...register("arteShare")}
                                />
                                <FormattedMessage id="nao" />
                              </div>
                            </div>
                          </div>
                          <div
                            className={`${
                              errors?.arteComment ? "input-error" : ""
                            }`}
                          >
                            <textarea
                              placeholder="Comente"
                              className="form-control form-control-sm feedback-categoria"
                              {...register("arteComment")}
                            />
                          </div>
                        </div>
                        <div className="form-group col-md-12 mb-4">
                          <div
                            className={`${errors?.som ? "input-error" : ""}`}
                          >
                            <h3>
                              <FormattedMessage id="games.detail.curators-evaluation.sound" />
                            </h3>
                            <div className="content-radio">
                              <div className="radio">
                                <input
                                  type="radio"
                                  className="form-control form-control-sm"
                                  value={"Sim"}
                                  {...register("som")}
                                />
                                <FormattedMessage id="sim" />
                              </div>
                              <div className="radio">
                                <input
                                  type="radio"
                                  className="form-control form-control-sm"
                                  value={"Não"}
                                  {...register("som")}
                                />
                                <FormattedMessage id="nao" />
                              </div>
                              <div className="radio">
                                <input
                                  type="radio"
                                  className="form-control form-control-sm"
                                  value={"Talvez"}
                                  {...register("som")}
                                />
                                <FormattedMessage id="talvez" />
                              </div>
                            </div>
                          </div>
                          <div
                            className={`${
                              errors?.somShare ? "input-error" : ""
                            }`}
                          >
                            <h3>
                              <FormattedMessage id="deseja-compartilhar-esse-comentario-com-o-desenvolvedor?" />
                            </h3>
                            <div className="content-radio">
                              <div className="radio">
                                <input
                                  type="radio"
                                  className="form-control form-control-sm"
                                  value={true}
                                  {...register("somShare", {
                                    value: "false",
                                  })}
                                />
                                <FormattedMessage id="sim" />
                              </div>
                              <div className="radio">
                                <input
                                  type="radio"
                                  className="form-control form-control-sm"
                                  value={false}
                                  {...register("somShare")}
                                />
                                <FormattedMessage id="nao" />
                              </div>
                            </div>
                          </div>
                          <div
                            className={`${
                              errors?.somComment ? "input-error" : ""
                            }`}
                          >
                            <textarea
                              placeholder="Comente"
                              className="form-control form-control-sm feedback-categoria"
                              {...register("somComment")}
                            />
                          </div>
                        </div>
                        <div className="form-group col-md-12 mb-4">
                          <div
                            className={`${
                              errors?.inovacao ? "input-error" : ""
                            }`}
                          >
                            <h3>
                              <FormattedMessage id="games.detail.curators-evaluation.innovation" />
                            </h3>
                            <div className="content-radio">
                              <div className="radio">
                                <input
                                  type="radio"
                                  className="form-control form-control-sm"
                                  value={"Sim"}
                                  {...register("inovacao")}
                                />
                                <FormattedMessage id="sim" />
                              </div>
                              <div className="radio">
                                <input
                                  type="radio"
                                  className="form-control form-control-sm"
                                  value={"Não"}
                                  {...register("inovacao")}
                                />
                                <FormattedMessage id="nao" />
                              </div>
                              <div className="radio">
                                <input
                                  type="radio"
                                  className="form-control form-control-sm"
                                  value={"Talvez"}
                                  {...register("inovacao")}
                                />
                                <FormattedMessage id="talvez" />
                              </div>
                            </div>
                          </div>
                          <div
                            className={`${
                              errors?.inovacaoShare ? "input-error" : ""
                            }`}
                          >
                            <h3>
                              <FormattedMessage id="deseja-compartilhar-esse-comentario-com-o-desenvolvedor?" />
                            </h3>
                            <div className="content-radio">
                              <div className="radio">
                                <input
                                  type="radio"
                                  className="form-control form-control-sm"
                                  value={true}
                                  {...register("inovacaoShare", {
                                    value: "false",
                                  })}
                                />
                                <FormattedMessage id="sim" />
                              </div>
                              <div className="radio">
                                <input
                                  type="radio"
                                  className="form-control form-control-sm"
                                  value={false}
                                  {...register("inovacaoShare")}
                                />
                                <FormattedMessage id="nao" />
                              </div>
                            </div>
                          </div>
                          <div
                            className={`${
                              errors?.inovacaoComment ? "input-error" : ""
                            }`}
                          >
                            <textarea
                              placeholder="Comente"
                              className="form-control form-control-sm feedback-categoria"
                              {...register("inovacaoComment")}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="form-row">
                        <div className="form-group content-btn col-12 d-flex justify-content-end">
                          <button
                            class="btn btn-outline-primary"
                            onClick={() => {
                              history.push(`/games/detail/${game.id}`);
                            }}
                          >
                            <FormattedMessage id="component.my-account-form.btn-cancel" />
                          </button>
                          <button type="submit" className="btn btn-primary">
                            <FormattedMessage id="games.detail.menu-game.rate" />
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
}

export default injectIntl(RatingGameSelecionadorGame);
